export class Translation {
  AddressAssignedMessage: string;
  TransportSuccessMessage: string;
  NoAssignedAddressMessage: string;
  NoAssignedModulesMessage: string;
  NoRightsForStatusCheckMessage: string;
  ContactAnAdministratorMessage: string;
  PasswordChange: string;
  Logout: string;
  Cancel: string;
  OldPassword: string;
  NewPassword: string;
  RepeatPassword: string;
  RepeatPasswordNotCorrectMessage: string;
  OldPasswordNotCorrectMessage: string;
  PasswordChanged: string;
  Success: string;
  Error: string;
  Transport: string;
  WheelNews: string;
  Cartec: string;
  AirportParking: string;
  StatusCheck: string;
  Administration: string;
  TransportDesc: string;
  WheelNewsDesc: string;
  CartecDesc: string;
  AirportParkingDesc: string;
  StatusCheckDesc: string;
  AdministrationDesc: string;
  Book: string;
  Visit: string;
  Check: string;
  Go: string;
  UserManagementCardTitle: string;
  UserManagementCardDesc: string;
  Manage: string;
  Assign: string;
  TransportTaskCardTitle: string;
  TransportTaskCardDesc: string;
  TransportTaskCardAction: string;
  DamageReportCardTitle: string;
  DamageReportCardDesc: string;
  DamageReportCardAction: string;
  TypeText: string;
  TraderText: string;
  AmountOfDaysSearch: string;
  All: string;
  Client: string;
  Sender: string;
  Recipient: string;
  OrderNumber: string;
  SenderCity: string;
  RecipientCity: string;
  Model: string;
  ChassisNumber: string;
  Reference: string;
  Status: string;
  DeliveryDate: string;
  TransportOrder: string;
  Contact: string;
  Email: string;
  Phone: string;
  AddressLine1: string;
  AddressLine2: string;
  Zip: string;
  City: string;
  ZipAndCity: string;
  Country: string;
  Vehicle: string;
  FreeText: string;
  OwnAddress: string;
  CoreData: string;
  Next: string;
  Back: string;
  ChooseSender: string;
  ChooseRecipient: string;
  ReadyForCollection: string;
  ChooseModel: string;
  CommissionNumber: string;
  Mark: string;
  Color: string;
  Remarks: string;
  Special: string;
  Confirm: string;
  FreightPayer: string;
  DeliveryOptions: string;
  Standard: string;
  Express1: string;
  Express2: string;
  Send: string;
  Number: string;
  LoginName: string;
  FirstName: string;
  LastName: string;
  Id: string;
  PartnerId: string;
  PartnerDescription: string;
  GroupDescription: string;
  ForeignId: string;
  Description: string;
  Addition: string;
  Street: string;
  User: string;
  Address: string;
  Module: string;
  Rights: string;
  MustBeFilled: string;
  MoreThan50CharactersAreNotAllowed: string;
  LastUpdate: string;
  CreationDate: string;
  PrimaryAddress: string;
  Partner: string;
  Companies: string;
  UserCreated: string;
  AutomaticPasswordAssignment: string;
  UserNotSavedMessage: string;
  UserSuccessfullySavedMessage: string;
  UserNotDeletedMessage: string;
  UserSuccessfullyDeletedMessage: string;
  IsChecked: string;
  Accepted: string;
  Declined: string;
  ScheduledForCollection: string;
  PickedUp: string;
  ScheduledForDelivery: string;
  Delivered: string;
  InTransit: string;
  PleaseDescribeSpecial: string;
  Comment: string;
  ChangeLanguage: string;
  ChoosePartner: string;
  Menu: string;
  None: string;
  CurrentUser: string;
  Express3: string;
  Express3Detail1: string;
  Express3Detail2: string;
  Express3Detail3: string;
  AddAdditionalVehicle: string;
  DeleteThisVehicle: string;
  Vehicles: string;
  Notification: string;
  FifteenMinutesBeforeNotification: string;
  ThirtyMinutesBeforeNotification: string;
  OneHourBeforeNotification: string;
  HighRoof: string;
  RotatingLightHighRoofRack: string;
  SnowPlow: string;
  Lowered: string;
  VehicleNotRunning: string;
  OthersPleaseDescribe: string;
  MustBeSeventeenDigits: string;
  More: string;
  Login: string;
  Password: string;
  ACompanyOf: string;
  Impressum: string;
  HomeHeaderTextLine1: string;
  HomeHeaderTextLine2: string;
  HomeHeaderTitle: string;
  WhatsGoingOn: string;
  LoginHeaderTitleLine1: string;
  LoginHeaderTitleLine2: string;
  UserNameMustBeFilled: string;
  PasswordMustBeFilled: string;
  PermissionDeniedError: string;
  DamageReport: string;
  DamageDate: string;
  Time: string;
  InsuranceType: string;
  OrderType: string;
  Causer: string;
  RepairWorkshop: string;
  Brand: string;
  Type: string;
  Identification: string;
  DriversDoor: string;
  AnotherDoor: string;
  Roof: string;
  FrontBumper: string;
  RearBumper: string;
  FrontFender: string;
  RearFender: string;
  Bonnet: string;
  RearCover: string;
  Windshield: string;
  RearWindow: string;
  SteeringWheel: string;
  UnderBody: string;
  Rim: string;
  Tire: string;
  SideMirror: string;
  CarSidebar: string;
  Headlights: string;
  Taillight: string;
  Various: string;
  Reset: string;
  CostEstimate: string;
  DragAndDropFileHere: string;
  Or: string;
  BrowseForFile: string;
  DamageReportSuccessMessage: string;
  DamageReportErrorMessage: string;
  BrandMustBeSelected: string;
  CostEstimateMustBeFilled: string;
  TypeMustBeSelected: string;
  SenderMustBeSelected: string;
  RecipientMustBeSelected: string;
  WorkshopMustBeSelected: string;
  Save: string;
  Edit: string;
  Language: string;
  Delete: string;
  CreatedBy: string;
  DoYouReallyWantToDeleteThisUser: string;
  WheelNewsOrder: string;
  Rims: string;
  AddAdditionalRim: string;
  DeleteThisRim: string;
  DifferentRecipientAddress: string;
  CurbDamage: string;
  PaintDamage: string;
  ImbalanceStraightening: string;
  Crack: string;
  WheelNewsOrderSuccessMessage: string;
  DamageType: string;
  PleaseDescribeDamageType: string;
  RimBrand: string;
  RimDiameter: string;
  RimWidth: string;
  RimAmount: string;
  RimModel: string;
  Inch: string;
  YouHaveToEnterAPassword: string;
  YouHaveToRepeatTheNewPassword: string;
  Welcome: string;
  PleaseChangeYourPassword: string;
  PleaseRepeatYourNewPassword: string;
  TermsAndConditions: string;
  Accept: string;
  Reject: string;
  VehicleSelection: string;
  PackageAndFotoSelection: string;
  BudgetPackage: string;
  StandardPackage: string;
  PremiumPackage: string;
  ExteriorFotos: string;
  InteriorFotos: string;
  ForEachVehicle: string;
  PleaseSelectAtLeastOneVehicle: string;
  PanoramaFotos: string;
  LogoAsWaterMark: string;
  PositionSelectable: string;
  IndividualDesign: string;
  WeContactYou: string;
  PriceIsOffered: string;
  WhereDoYouWantToPlaceTheLogo: string;
  Top: string;
  Bottom: string;
  Left: string;
  Right: string;
  SelectionText1: string;
  SelectionText2: string;
  SelectionText3: string;
  Warning: string;
  FotoboxPackageWarning: string;
  SelectFotosYourself: string;
  StandardSelection: string;
  ShoppingCartHide: string;
  ShoppingCartShow: string;
  Fotobox: string;
  SendOrder: string;
  ShoppingCart: string;
  Total: string;
  WheelNewsTaskCardTitle: string;
  WheelNewsTaskCardDesc: string;
  WheelnewsTaskCardAction: string;
  WheelnewsOrderviewCardTitle: string;
  WheelnewsOrderviewCardDesc: string;
  WheelnewsOrderviewCardAction: string;
  Order: string;
  Repaint: string;
  PleaseDescribeRepaint: string;
  MoreThan5FilesPerSetAreNotAllowed: string;
  FilesOver5MBAreNoteAllowed: string;
  Repair: string;
  OrderArt: string;
  PickUpSlip: string;
  PickUpSlipTextRow1: string;
  PickUpSlipTextRow2: string;
  PickUpSlipTextRow3: string;
  PickUpSlipTextRow4: string;
  KindRegards: string;
  OrderInformations: string;
  OrderDescription: string;
  RepairDescription: string;
  RepaintDescription: string;
  ConfirmationMailText1: string;
  ConfirmationMailText2: string;
  ConfirmationMailText3: string;
  ConfirmationMailText4: string;
  ConfirmationMailText5: string;
  ConfirmationMailText6: string;
  ConfirmationMailText7: string;
  ConfirmationMailText8: string;
  OrderConfirmation: string;
  DeliverySlip: string;
  ShowDeliverySlips: string;
  Close: string;
  FotoboxDesc: string;
  Modules: string;
  YouCantDeleteYourself: string;
  Change: string;
  MoreThan1LogoIsNotAllowed: string;
  FileSizeExceeded: string;
  InvalidCommissionNumber: string;
  OrderDate: string;
  PickUpDate: string;
  SparePartNumber: string;
  Information: string;
  Express: string;
  IsBroughtByCustomer: string;
  Standard2: string;
  AgbHeaderPart1: string;
  AgbHeaderPart2: string;
  Agb1Header: string;
  Agb1Line1: string;
  Agb1Line2: string;
  Agb2Header: string;
  Agb2Line1: string;
  Agb3Header: string;
  Agb3Line1: string;
  Agb4Header: string;
  Agb4Line1: string;
  Agb4Line2: string;
  Agb4Line3: string;
  Agb4Line4: string;
  Agb41Header: string;
  Agb41Line1: string;
  Agb41Line2: string;
  Agb42Header: string;
  Agb42Line1: string;
  Agb43Header: string;
  Agb43Line1: string;
  Agb5Header: string;
  Agb5Line1: string;
  Agb51Header: string;
  Agb51Line1: string;
  Agb51Line2: string;
  Agb52Header: string;
  Agb52Line1: string;
  Agb6Header: string;
  Agb6Line1: string;
  Agb7Header: string;
  Agb7Line1: string;
  Agb8Header: string;
  Agb8Line1: string;
  Agb8Line2: string;
  Subject: string;
  Company: string;
  Message: string;
  RequestLogin: string;
  LoginRequest: string;
  DeliverOn: string;
  DeliveryDateChangedWeekend: string;
  DeliveryDateChangedHoliday: string;
  News: string;
  Home: string;
  Salutation: string;
  UserCreatedEmailText1: string;
  UserCreatedEmailText2: string;
  YourCotraTeam: string;
  UserCreatedEmailSubject: string;
  MessageSentTitle: string;
  MessageSentText: string;
  ResetPassword: string;
  PasswordResetEmailSubject: string;
  PasswordResetEmailText1: string;
  PasswordResetEmailText2: string;
  PasswordResetSuccessMessage: string;
  PasswordResetErrorMessage: string;
  BringDate: string;
  BringAppointment: string;
  IsPickedUpByCustomer: string;
  RecipientSameAsSender: string;
  PickUpSlipTextRow5: string;
  VehicleInformation: string;
  Scratch: string;
  Bump: string;
  GlassDamage: string;
  FactoryDamage: string;
  Others: string;
  YouMustAddAFoto: string;
  PleaseAddAComment: string;
  DataFormatNotSupported: string;
  PleaseSelectADamageType: string;
  PleaseUploadAFotoForeachDamageTypeYouSelected: string;
  AddNewDamageReport: string;
  EditExistingDamageReports: string;
  AreYouSure: string;
  AreYouSurePart2: string;
  Yes: string;
  No: string;
  NoIamNot: string;
  YouMustSelectAtLeastOneDamage: string;
  DamageReportSuccessWithInfoMessage: string;
  YourChangesWereSuccessfullySaved: string;
  ProblemWhileSavingChanges: string;
  YouSelectedTooManyFiles: string;
  YouMustUploadAtLeastOneFotoForEachSelectedDamageType: string;
  YouCannotUploadMoreThanTwoFotoEachDamageType: string;
  DamageReports: string;
  ClosedDamageReports: string;
  Search: string;
  ForgotPassword: string;
  PleaseEnterYourEmail: string;
  ResetPasswordNotification1: string;
  ResetPasswordNotification2: string;
  ResetPasswordNotification3: string;
  ResetPasswordNotification4: string;
  ResetPasswordNotification5: string;
  ResetPasswordNotification6: string;
  ResetPasswordNotification7: string;
  ResetPasswordNotification8: string;
  ChangeYourCotraPortalPassword: string;
  ResetPasswordMailText1: string;
  ResetPasswordMailText2: string;
  ResetPasswordMailText3: string;
  ResetPasswordMailText4: string;
  ResetPasswordMailHeader1: string;
  ResetPasswordMailText5: string;
  ResetPasswordMailText6: string;
  ResetPasswordMailHeader2: string;
  Settings: string;
  MultiPartnerUser: string;
  WeHaveMoved: string;
  WeHaveMovedMessage: string;
  UploadFile: string;
  FileSuccessfullyUploaded: string;
  FileNotUploaded: string;
  LoadVehicleDataByAddresses: string;
  LoadVehicleDataByReferences: string;
  LoadData: string;
  YouMustFillChassisOrReference: string;
  HomeDeliveryUser: string;
  HomePickUpUser: string;
  MoreThan5FilesAreNotAllowed: string;
  ReadyForPickUp: string;
  SendConfirmationMail: string;
  ConfirmationMailTitle: string;
  NoJustThisTime: string;
  ConfirmationMailSettingSuccessfullySaved: string;
  Oops: string;
  On: string;
  AsOf: string;
  MaintenancePart1: string;
  MaintenancePart2: string;
  MaintenancePart3: string;
  ConfirmationMailAsked: string;
  SaturdayDeliveryAllowed: string;
  ConfirmationMail: string;
  MyFotos: string;
  Value: string;
  PayDate: string;
  Actions: string;
  Download: string;
  Pay: string;
  DeleteCancel: string;
  Optional: string;
  Prices: string;
  SingleFoto: string;
  RemoveBackground: string;
  SpinImage: string;
  Resolutions: string;
  Select: string;
  Crop: string;
  ShortSelect: string;
  ShortCrop: string;
  Example: string;
  InteractiveHtmlFile: string;
  InclusiveFilesAsJpg: string;
  RemoveVehicle: string;
  Subtotal: string;
  SaveSelection: string;
  InvoiceAddress: string;
  Sir: string;
  Mrs: string;
  StreetAndNumber: string;
  AdditionalAddress: string;
  PhoneOrMobile: string;
  AgbText1: string;
  AgbText2: string;
  AgbText3: string;
  OrderSuccessfulMessage1: string;
  OrderSuccessfulMessage2: string;
  OrderCancelledMessage1: string;
  OrderCancelledMessage2: string;
  OrderProblemMessage: string;
  DoYouReallyWantToDeleteThisOrder: string;
  NoFotosFoundForThisVehicle: string;
  YouHaveNotSelectedAnyFotos: string;
  YouHaveUnsavedChangesAtVehicle: string;
  IfYouGoBackAllWillBeResetted: string;
  PleaseAcceptOurAgbs: string;
  Missing: string;
  FotoboxShop: string;
  FotoboxShopText: string;
  MyFotosText: string;
  InternalServerError: string;
  YouHaveNoRightToDoThat: string;
  Salutation2: string;
  AmountOfFotos: string;
  PriceInCHF: string;
  Till: string;
  From: string;
  RemoveBackground2: string;
  DesiredModules: string;
  Register: string;
  CheckYourInputs: string;
  RegistrationSuccessful: string;
  YouCanLoginNow: string;
  Date: string;
  EstimatedDelivery: string;
  VehicleLogistics: string;
  VehicleLogisticsDesc: string;
  LogisticsTaskCardTitle: string;
  LogisticsTaskCardDesc: string;
  LogisticsTaskCardAction: string;
  ProcessId: string;
  SendAgain: string;
  MarkAddition: string;
  NeedsBooster: string;
  HomeDeliveryCardTitle: string;
  HomeDeliveryCardDesc: string;
  HomeDeliveryCardAction: string;
  HomeDeliveryPartnerAddress: string;
  ProcessIds: string;
  OrderSource: string;
  Express4: string;
  ExternalStateOpen: string;
  ExternalStateRejected: string;
  ExternalStateBeingProcessed: string;
  ExternalStateClosed: string;
  ControlPlate: string;
  OpenDamageCases: string;
  DamageCaseSuccessMessage: string;
  AddImageErrorMessage: string;
  AddImageErrorMessageMaxFour: string;
  AddDamageErrorMessageNoArea: string;
  AddDamageErrorMessageNoType: string;
  AddDamageErrorMessageNoImage: string;
  AddFile: string;
  DocumentType: string;
  FileName: string;
  DamageArea: string;
  AddDamage: string;
  AddImagesMaxFour: string;
  Documents: string;
  Damages: string;
  Activity: string;
  WriteSomething: string;
  NoActivitesToThisCase: string;
  DamageCaseValidationMessageCostEstimateAmount: string;
  DamageCaseValidationMessageCostEstimateFile: string;
  New: string;
  ReportNewDamageCase: string;
  Open: string;
  EditAndViewDamageCases: string;
  Completed: string;
  OverviewClosedDamageCases: string;
  Invoice: string;
  DamageCaseValidationMessageDamageAmount: string;
  DamageCaseValidationMessageInvoiceFile: string;
  AccountAssignmentInfoTest: string;
  DifferentVehicle: string;
  SenderMustBeFilled: string;
  RecipientMustBeFilled: string;
  IdentificationMustBeFilled: string;
  VehcileMustBeFilled: string;
  ChassisNoMustBeFilled: string;
  LicensePlateMustBeFilled: string;
}
